import { type TutorialStatusConstructor } from '@webapp/platform/iam/entities/TutorialStatus'
import { type TutorialStatusApiModel } from '../api-models/TutorialStatusApiModel'

export const mapTutorialStatusApiModel = (
  raw: TutorialStatusApiModel
): TutorialStatusConstructor => ({
  isPunchOutApprovalWarningSuppressed: Boolean(
    raw.approval?.punchout_confirmation
  ),
})
